import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { UserService } from '../../services/api-services/user.service';
@Component({
  selector: 'app-confirm-tranfer-tenant-ring',
  templateUrl: './confirm-tranfer-tenant-ring.component.html',
  styleUrl: './confirm-tranfer-tenant-ring.component.scss'
})
export class ConfirmTranferTenantRingComponent {
  isLoading = false;
  constructor(
    public dialogRef: MatDialogRef<ConfirmTranferTenantRingComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private toastr: ToastrService,
    private userService: UserService
  ) { }

  confirmTransfer() {
    this.isLoading = true;
    const payload: any = {
      message_id: this.data.item?.message_id,
      db_tenant: this.data.item?.db_tenant
    };
    if (this.data.item?.transfer_request_id) {
      payload.transfer_request_id = this.data.item.transfer_request_id;
    }
    this.userService.sendRCPrescriptionToTenant(payload).subscribe({
      next: (res: any) => {
        if (res && res?.body?.success) {
          this.isLoading = false;
          this.toastr.success(res.body.message);
          this.dialogRef.close(true);
        } else {
          this.isLoading = false;
          this.toastr.error(res.body.message || 'Failed to update additional coverage status');
          this.dialogRef.close(false);
        }
      }, error: (error) => {
        this.isLoading = false;
        console.error('error::', error);
        this.toastr.error('Error updating additional coverage status');
      }
    });
  }

  moveToArchive() {
    this.isLoading = true;
    var payload = {}
    if (this.data.item?.action == 'transferToActive') {
      payload = {
        message_id: this.data.item?.message_id,
        id: this.data.item?.id,
        status_value: 0
      };
    } else if (this.data.item?.action == 'transferToArchive') {
      payload = {
        message_id: this.data.item?.message_id,
        id: this.data.item?.id,
        status_value: 1
      };
    }
    this.userService.move_to_archive(payload).subscribe({
      next: (res: any) => {
        if (res && res?.body?.success) {
          this.isLoading = false;
          this.toastr.success(res.body.message);
          this.dialogRef.close(true);
        } else {
          this.isLoading = false;
          this.toastr.error(res.body.message || 'Failed to move prescription to archive');
          this.dialogRef.close(false);
        }
      }, error: (error) => {
        this.isLoading = false;
        console.error('error::', error);
        this.toastr.error('Error moving prescription to archive');
        this.dialogRef.close(false);
      }
    });
  }

  updateStatus() {
    this.isLoading = true;
    const payload = {
      message_id: this.data.item?.message_id,
      id: this.data.item?.id,
      prescription_type_id: this.data.item?.prescription_type,
      update_from: this.data.item?.update_from ? 'prescription' : 'ringcentral'
    }
    this.userService.update_pres_type(payload).subscribe({
      next: (res: any) => {
        if (res && res?.body?.success) {
          this.isLoading = false;
          this.toastr.success(res.body.message);
          this.dialogRef.close(true);
        } else {
          this.isLoading = false;
          this.toastr.error(res.body.message || 'Failed to update prescription type');
          this.dialogRef.close(false);
        }
      }, error: (err) => {
        this.isLoading = false;
        console.error('error::', err);
        this.toastr.error(err?.error?.message || 'Error updating prescription type');
        this.dialogRef.close(false);
      }
    });
  }

  mapDialougeFax() {
    if (!this.data.item?.prescription_id) {
      this.toastr.warning('Prescription ID is required.');
      return;
    }
    this.isLoading = true;
    const payload = {
      message_id: this.data.item?.message_id,
      db_tenant: this.data.item?.db_tenant,
      prescription_id: this.data.item?.prescription_id
    };
    this.userService.map_dialouge_fax(payload).subscribe({
      next: (res: any) => {
        if (res && res?.body?.success) {
          this.isLoading = false;
          this.toastr.success(res.body.message);
          this.dialogRef.close(true);
        } else {
          this.isLoading = false;
          this.toastr.error(res.body.message || 'Failed to map dialogue fax');
          this.dialogRef.close(false);
        }
      },
      error: (err) => {
        this.isLoading = false;
        console.error('error::', err);
        this.toastr.error(err?.error?.message || 'Error mapping dialogue fax');
      }
    });
  }

  confirmRxId() {
    this.isLoading = true;
    const payload = {
      message_id: this.data.item?.message_id,
      db_tenant: this.data.item?.db_tenant,
      transper_prescription_id: this.data.item?.transfer_request_id
    }
    this.userService.confirm_rx_id(payload).subscribe({
      next: (res: any) => {
        if (res && res?.body?.success) {
          this.isLoading = false;
          this.toastr.success(res.body.message);
          this.dialogRef.close(true);
        } else {
          this.isLoading = false;
          this.toastr.error(res.body.message || 'Failed to add RxID for transfer prescription');
          this.dialogRef.close(false);
        }
      }, error: (err) => {
        this.isLoading = false;
        console.error('error::', err);
        this.toastr.error(err?.error?.message || 'Error adding RxID for transfer prescription');
        this.dialogRef.close(false);
      }
    });
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
